import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Spinner, Col, Row } from 'react-bootstrap';

import useGlobal from '../../store';
import TimbradoRetencionInfo from './info/TimbradoRetencionInfo';

const mapState = (store) => {
  return {
    audits: store.developer.stamping.retencion,
  };
};

const mapActions = (actions) => {
  return { ...actions.developer.stamping.retencion };
};

const TimbradoRetencionesInfo = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state.audits;

  useEffect(() => {
    const { data = {} } = props.location.state || {};
    actions.change(data);

    return () => {
      actions.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const { id } = props.match.params || {};

    if (!!id) {
      actions.info(id);
    } else {
      props.history.replace({
        pathname: `/developers/timbrado/retenciones`,
      });
    }

    return () => {
      actions.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="page-header">
        <Link to="/developers/timbrado/retenciones">&#8592; Audits</Link>
      </div>

      <h5>
        <Row>
          <Col>
            {!!busy && (
              <Spinner
                animation="border"
                role="status"
                size="sm"
                className="mr-3"
              >
                <span className="sr-only">Recuperando información...</span>
              </Spinner>
            )}
            {data.id || '...'}
          </Col>
        </Row>
      </h5>

      {!!data.idx && (
        <div>
          <div className="d-block mt-3 mb-2">
            <strong className="text-muted">Detalles</strong>
          </div>

          <TimbradoRetencionInfo data={data} />
        </div>
      )}
    </>
  );
};

export default TimbradoRetencionesInfo;
